import axios from 'axios';
import { IStatusResponse } from '@/dealroom/integrations/google/types/status-response';
import { IUploadData } from '@/dealroom/integrations/google/types/upload-data';

export default class GoogleService {
  static async upload(fileName: string, fileUrl: string): Promise<IUploadData> {
    const body = new FormData();
    body.append('file_url', fileUrl);
    body.append('file_name', fileName);
    const { data } = await axios.post('/save/upload', body);
    return data;
  }

  static async save(
    filename: string,
    documentId: string,
    pageIndex: number = 1
  ): Promise<IStatusResponse> {
    const body = new FormData();
    body.append('action', 'import');
    body.append('document-id', documentId);
    body.append('upload-file-list', filename);
    body.append('index', pageIndex.toString());
    const { data } = await axios.post('/save/document', body);
    return data;
  }

  static async saveImportLog(documentId: string): Promise<IStatusResponse> {
    const body = new FormData();
    body.append('action', 'import-log');
    body.append('document-id', documentId);
    body.append('file-src', 'drive');
    const { data } = await axios.post('/save/document', body);
    return data;
  }

  static async getModified(
    documentId: string,
    editorId: string,
    editorType: string,
    title: string
  ): Promise<boolean> {
    const encodedTitle: string = encodeURIComponent(title);
    const params: string[] = [
      'action=save',
      `document-id=${documentId}`,
      `editor-id=${editorId}`,
      `title=${encodedTitle}`,
    ];
    const url: string = `/auth/${editorType}/?${params.join('&')}`;
    const { data } = await axios.get(url);
    return !!data.modified;
  }
}
